import { Navigate } from "react-router-dom";
import { selectedUser } from "../../features/auth/authSlice";
import SignupFormComponent from "../../features/auth/components/SignupForm";
import { useAppSelector } from "../../hooks/redux/hooks";
import { emailStatuses } from "../../features/auth/models/EmailStatus.interface";

const Signup = () => {

  const { isAuthenticated, verificationEmail } = useAppSelector(selectedUser);

  if (isAuthenticated && verificationEmail?.emailStatus === emailStatuses.NotVerified) {
    return <Navigate replace to='/email-verification' />
  }


  return (
    <>
      <SignupFormComponent />
    </>
  );
};

export default Signup;
